module.exports = __webpack_public_path__ + "img/custom_bg1.b1620098.png";